export const INSERT_TEAM = "INSERT_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
